// extracted by mini-css-extract-plugin
export default {"contenedorCargando":"styles_contenedorCargando__55lJf"};